<template>
  <v-expansion-panel>
    <div class="section-box section-box-list" v-for="(item,i) in 1" :key="i">
      <v-expansion-panel-content expand-icon="fal fa-angle-down">
        <div slot="header">
          <v-tooltip bottom>
            <span slot="activator"><strong>{{ healthCard.created_at | moment('DD/MM/YYYY') }}</strong></span>
            <span>{{ healthCard.created_at | moment('DD/MM/Y, HH:mm') }}</span>
          </v-tooltip>
          <span style="margin: 0 10px; color: #999;">|</span>
          <span>AVALIAÇÃO INICIAL</span>
        </div>
        <section class="my-4 mx-2">
          <health-card-item :healthCard="healthCard"></health-card-item>
        </section>
      </v-expansion-panel-content>
    </div>
  </v-expansion-panel>
</template>

<script>
import UserHealthCardItem from '@/components/user/evaluations/UserHealthCardItem'

export default {
  props: ['healthCard'],

  components: {
    'health-card-item': UserHealthCardItem
  }
}
</script>

<style scoped>
.section-box-list {
  margin-top: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/user/evaluations/UserHealthCard.vue